import React, { useEffect, useState } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { getInventoryItemValidate } from "../../../../graphql/inventory/custom-queries";
import { createInventoryItem } from "../../../../graphql/mutations";

import {
  Box,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { Button } from "react-admin";

import { CancelIcon, CloseIcon } from "../../../../components/common/iconography";
import {
  InventoryStatus,
  LocationType,
  NoteType,
  originDamageList,
  Unit,
} from "../../../../utils/constants";
import {
  getLocationFullName,
  isBulkArea,
  isTrack,
  promiseSetCapacityUsed,
} from "../../../../utils/locationUtils";
import { getUnitName } from "../../../../utils/loadTypeUtils";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    display: "flex",
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
    justifyContent: "space-between",
  },
  title: {
    paddingTop: theme.spacing(1),
  },
  dialogContent: {
    // https://stackoverflow.com/questions/47698037/how-can-i-set-a-height-to-a-dialog-in-material-ui
    minHeight: "50vh",
  },
}));

export const isOnHand = (record) => {
  return (
    record?.status !== InventoryStatus.IN_TRANSIT &&
    record?.status !== InventoryStatus.ARRIVED
  );
};

export const ExceptionDialog = ({
  record,
  isExceptionDialogOpen,
  setIsExceptionDialogOpen,
  inventory,
  exceptions,
  setExceptions,
  isQtyDisabled,
  isOverUnderShipmentDisabled,
  showDisabledOverUnderShipment,
}) => {
  const classes = useStyles();
  const [damageExceptionNoteError, setDamageExceptionError] = useState();
  const [otherExceptionNoteError, setOtherExceptionError] = useState();
  const [tempExceptions, setTempExceptinos] = useState({ ...exceptions });
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));

  useEffect(() => {
    if (isExceptionDialogOpen) {
      setTempExceptinos({ ...exceptions });
    }
  }, [isExceptionDialogOpen]);

  const validate = () => {
    let isValid = true;
    setDamageExceptionError("");
    setOtherExceptionError("");

    if (tempExceptions.isDamaged) {
      isValid = isValid && tempExceptions.originOfDamage;
      !isValid && setDamageExceptionError("Required");
    }
    if (tempExceptions.otherException) {
      isValid = isValid && tempExceptions.otherExceptionNote;
      !tempExceptions.otherExceptionNote && setOtherExceptionError("Required");
    }

    return isValid;
  };

  const handleSave = async () => {
    debugger;
    if (!validate()) return;
    const prevExceptions = { ...tempExceptions };

    prevExceptions.hasException =
      tempExceptions.overShipment ||
      tempExceptions.underShipment ||
      tempExceptions.isDamaged ||
      tempExceptions.otherException;
    setExceptions({ ...prevExceptions });
    setIsExceptionDialogOpen(false);
  };

  const handleChange = (evt) => {
    const type = evt.target.name;
    const value = evt.target.checked;
    const prevExceptions = { ...tempExceptions };
    debugger;

    if (
      isOverUnderShipmentDisabled &&
      (type === "overShipment" || type === "underShipment")
    ) {
      return;
    }

    if (type === "overShipment") {
      prevExceptions.overShipment = value;
      prevExceptions.underShipment = value
        ? false
        : tempExceptions.underShipment;
      if (!value) tempExceptions.overShipmentNote = inventory.overShipmentNote;
    } else if (type === "underShipment") {
      prevExceptions.underShipment = value;
      prevExceptions.overShipment = value ? false : tempExceptions.overShipment;
      if (!value)
        prevExceptions.underShipmentNote = inventory.underShipmentNote;
    } else if (type === "isDamaged") {
      prevExceptions.isDamaged = value;
      if (!value) prevExceptions.originOfDamage = "";
    } else {
      prevExceptions.otherException = value;
      if (!value) {
        prevExceptions.otherExceptionNote = "";
        setOtherExceptionError("");
      }
    }

    setTempExceptinos({ ...prevExceptions });
  };

  const handleCancel = () => {
    setIsExceptionDialogOpen(false);
    setTempExceptinos({});
  };

  const setNote = (prop, value) => {
    debugger;
    setTempExceptinos((tempExceptions) => ({
      ...tempExceptions,
      [prop]: value,
    }));
    if (prop === "originOfDamage" && value) setDamageExceptionError("");
  };

  const showOverUnderShipment =
    (!isQtyDisabled && !isOverUnderShipmentDisabled) ||
    showDisabledOverUnderShipment;
  const hasOverShipment = !!tempExceptions.overShipment;
  const hasUnderShipment = !!tempExceptions.underShipment;

  return (
    <Dialog
      open={isExceptionDialogOpen}
      maxWidth={isSmall ? "xl" : "md"}
      fullWidth={true}
    >
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Typography className={classes.title} variant="h6">
          Exception Manager
        </Typography>
        <IconButton aria-label="close" onClick={handleCancel}>
          <CloseIcon fontSize="large" />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <FormControl component="fieldset" className={classes.formControl}>
              <FormLabel>
                <Typography variant="overline" color="textSecondary">
                  Exception Type
                </Typography>
              </FormLabel>
              <FormGroup row={!isSmall}>
                {showOverUnderShipment && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="overShipment"
                        checked={hasOverShipment}
                        onChange={handleChange}
                        disabled={isOverUnderShipmentDisabled}
                      />
                    }
                    label="Overshipment"
                  />
                )}
                {isOnHand(record) && showOverUnderShipment && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="underShipment"
                        checked={hasUnderShipment}
                        onChange={handleChange}
                        disabled={isOverUnderShipmentDisabled}
                      />
                    }
                    label="Undershipment"
                  />
                )}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tempExceptions.isDamaged}
                      onChange={handleChange}
                      name="isDamaged"
                      disabled={inventory.status === InventoryStatus.IN_TRANSIT}
                    />
                  }
                  label="Damaged"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tempExceptions.otherException}
                      onChange={handleChange}
                      name="other"
                    />
                  }
                  label="Other"
                />
              </FormGroup>
            </FormControl>
          </Grid>
          {showOverUnderShipment && hasOverShipment && (
            <Grid item xs={12}>
              <TextField
                name="overShipmentNote"
                label="Overshipment Notes"
                multiline
                minRows={3}
                autoFocus
                margin="dense"
                variant="outlined"
                fullWidth
                value={
                  tempExceptions.overShipmentNote
                    ? tempExceptions.overShipmentNote
                    : ""
                }
                disabled={isOverUnderShipmentDisabled}
                onChange={(evt) =>
                  setNote("overShipmentNote", evt.target.value)
                }
                helperText={`Overshipment Qty: ${tempExceptions.overShipmentQuantity || 0}`}
              />
            </Grid>
          )}
          {showOverUnderShipment && hasUnderShipment && (
            <Grid item xs={12}>
              <TextField
                name="underShipmentNote"
                label="Undershipment Notes"
                multiline
                minRows={3}
                autoFocus
                margin="dense"
                variant="outlined"
                fullWidth
                value={
                  tempExceptions.underShipmentNote
                    ? tempExceptions.underShipmentNote
                    : ""
                }
                disabled={isOverUnderShipmentDisabled}
                onChange={(evt) =>
                  setNote("underShipmentNote", evt.target.value)
                }
                helperText={`Undershipment Qty: ${tempExceptions.underShipmentQuantity || 0}`}
              />
            </Grid>
          )}
          {tempExceptions.isDamaged && (
            <Grid item xs={12}>
              <TextField
                select
                id="originOfDamage"
                label="Damage Origin"
                variant="outlined"
                size="small"
                fullWidth
                required
                value={
                  tempExceptions.originOfDamage
                    ? tempExceptions.originOfDamage
                    : ""
                }
                onChange={(evt) => setNote("originOfDamage", evt.target.value)}
                error={damageExceptionNoteError}
                helperText={damageExceptionNoteError}
              >
                {[
                  { id: "", value: "", name: <span>&nbsp;</span> },
                  ...originDamageList,
                ].map((itm) => (
                  <MenuItem key={itm.id} value={itm.id}>
                    {itm.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )}
          {tempExceptions.otherException && (
            <Grid item xs={12}>
              <TextField
                name="otherExceptionNote"
                label="Other Notes"
                multiline
                minRows={3}
                autoFocus
                error={otherExceptionNoteError}
                helperText={otherExceptionNoteError}
                margin="dense"
                variant="outlined"
                required
                fullWidth
                value={
                  tempExceptions.otherExceptionNote
                    ? tempExceptions.otherExceptionNote
                    : ""
                }
                onChange={(evt) =>
                  setNote("otherExceptionNote", evt.target.value)
                }
              />
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Box>
          <Box>
            <Button
              label="Cancel"
              color="default"
              onClick={() => handleCancel()}
            >
              <CancelIcon />
            </Button>
            <Button
              label="Submit"
              onClick={() => handleSave()}
              color="primary"
            />
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export const handleAreaZoneLocation = (
  area,
  zone,
  aisle,
  location,
  outboundShipment,
  form,
) => {
  // area is required. areaId already set in AreaZonePicker
  form.change("area", area);

  if (zone) {
    form.change("zoneId", zone.id);
    form.change("zone", zone);
  } else {
    form.change("zoneId", "");
    form.change("zone", null);
  }

  if (aisle) {
    form.change("aisleId", aisle.id);
    form.change("aisle", aisle);
  } else {
    form.change("aisleId", "");
    form.change("aisle", null);
    form.change("quantityOnHand", null);
  }

  if (location) {
    location.area = area;
    location.zone = zone;
    location.aisle = aisle;
    form.change("location", location);
    form.change("locationId", location.id);
    form.change("locationFullName", getLocationFullName(location));
  } else {
    form.change("locationId", "");
    form.change("location", null);
    form.change("locationFullName", "");
  }

  if (outboundShipment) {
    form.change("outboundShipmentId", outboundShipment.id);
  } else {
    form.change("outboundShipmentId", "");
  }
};

export const isAllocatable = (inventory) => {
  return (
    inventory?.status === InventoryStatus.IN_TRANSIT ||
    inventory?.status === InventoryStatus.ARRIVED
  );
};

export const getInventoryItemStatus = (inventory) => {
  if (inventory.status === InventoryStatus.IN_TRANSIT)
    return InventoryStatus.IN_TRANSIT;
  else if (inventory.status === InventoryStatus.ARRIVED)
    return InventoryStatus.IN_TRANSIT;
  return inventory.status;
};

export const shouldSplitUnitInventoryItems = ({ inventoryUOM, area }) => {
  return inventoryUOM === Unit.UNIT && !isTrack(area) && !isBulkArea(area);
};

export const shouldSplitUnitInventoryItemsAtLocation = ({
  inventoryUOM,
  location,
  inventoryArea,
}) => {
  return shouldSplitUnitInventoryItems({
    inventoryUOM,
    area: location?.area || inventoryArea,
  });
};

export const getInventoryItemQuantityOnHand = ({
  inventoryUOM,
  putawayQuantity,
  location,
  inventoryArea,
}) => {
  return shouldSplitUnitInventoryItemsAtLocation({
    inventoryUOM,
    location,
    inventoryArea,
  })
    ? 1
    : putawayQuantity;
};

export const getInventoryItem = (
  data,
  inventory,
  location,
  putawayQuantity,
  exceptions,
) => {
  const locationFullName = getLocationFullName(location);

  const toCreateInventoryItem = {
    groups: inventory.groups,
    status: getInventoryItemStatus(inventory),
    inventoryId: inventory.id,
    accountId: inventory.accountId,
    inboundShipmentId: inventory.inboundShipmentId,
    reloadYardId: inventory.reloadYardId,
    areaId: location.areaId,
    zoneId: location.zoneId,
    aisleId: location.aisleId,
    locationId: location.id,
    location: location,
    outboundShipmentId: data?.outboundShipmentId,
    locationFullName: locationFullName,
    quantityOnHand: getInventoryItemQuantityOnHand({
      inventoryUOM: inventory.inventoryUOM,
      putawayQuantity,
      location,
      inventoryArea: inventory.area,
    }),
    quantityCommitted: 0,
    hasException: exceptions?.hasException,
    isDamaged: exceptions?.isDamaged,
    originOfDamage: exceptions?.originOfDamage,
    otherException: exceptions?.otherException,
    otherExceptionNote: exceptions?.otherExceptionNote,
    // createdAt: new Date() // used for sorting only. delete on transform.
  };

  toCreateInventoryItem.history = [
    {
      type: NoteType.INVENTORY,
      date: new Date(),
      by: window.appUser?.fullName,
      text: `Allocated ${toCreateInventoryItem.quantityOnHand} ${getUnitName(
        inventory.inventoryUOM,
      )} to ${locationFullName}`,
    },
  ];

  return toCreateInventoryItem;
};

export const promiseCreateInventoryItem = (inventoryItem) => {
  const toCreateInventoryItem = { ...inventoryItem };
  debugger;
  delete toCreateInventoryItem.aisle;
  delete toCreateInventoryItem.area;
  delete toCreateInventoryItem.inventory;
  delete toCreateInventoryItem.location;
  delete toCreateInventoryItem.outboundShipment;
  delete toCreateInventoryItem.putawayQuantity;
  delete toCreateInventoryItem.zone;
  return API.graphql(
    graphqlOperation(createInventoryItem, { input: toCreateInventoryItem }),
  );
};

export const promiseSetCapacityAllocated = async (
  location,
  capacityAllocated,
) => {
  promiseSetCapacityUsed(location, location.capacityUsed, capacityAllocated);
};

export const allocateCapacity = (inventory, inventoryItem) => {
  const location = inventoryItem.location;

  if (location.type === LocationType.BULK) {
    // perform BULK capacity update
    location.capacityAllocated =
      (location.capacityAllocated || 0) + inventoryItem.putawayQuantity;
  } else if (
    location.type === LocationType.STRUCTURED &&
    !location.locationLoad?.other.selected
  ) {
    // if STRUCTURED & not OTHER, update Capacity Used
    // if (inventory.inventoryUOM !== Unit.UNIT) {
    const inventoryLoadType =
      inventory.reloadYardCommodity?.commodity?.locationLoadType;
    const locationLoadType = location.locationLoad[inventoryLoadType];
    location.capacityAllocated =
      (location.capacityAllocated || 0) + locationLoadType.capacity;
    if (!location.productId && inventory.productId)
      location.productId = inventory.productId;
    // }
  }
};

export const compareObjects = (obj1, obj2) => {
  for (let key in obj1) {
    if (obj1[key] !== obj2[key]) {
      return false; // Return false as soon as one value does not match
    }
  }
  return true; // Return true if all values match
};

export async function validateInventoryItemBeforeUpdate(formData) {
  const staleErrors = [];
  debugger;

  // ——— 1) Always validate outbound.updatedAt ———
  let dbInventoryItem = null;
  const result = await API.graphql(
    graphqlOperation(getInventoryItemValidate, { id: formData.id }),
  );
  dbInventoryItem = result.data.getInventoryItem;
  if (!dbInventoryItem) {
    staleErrors.push(`Inventory Item deleted.`);
    // abort further validation
    return { staleErrors };
  } else if (
    new Date(dbInventoryItem.updatedAt) > new Date(formData.updatedAt)
  ) {
    staleErrors.push(`Inventory Item changed.`);
  }

  const dbInventory = dbInventoryItem.inventory;
  const formInventory = formData.inventory;
  if (!dbInventory) {
    staleErrors.push(`Inventory deleted.`);
    // abort further validation
    return { staleErrors };
  } else if (
    new Date(dbInventory.updatedAt) > new Date(formInventory.updatedAt)
  ) {
    staleErrors.push(`Inventory changed.`);
  }

  return { staleErrors };
}
